<template>
<div>
    <!-- fixed-bottom-nav -->
    <div class="bottombar-large" style="display:none; margin-top:5em; margin-left: -2em; width: 400px;">
        <div style="padding-left:1em;">
            <a href="/"><i class="fa fa-list"></i><br><span>Feeds</span></a>
            <a href="/shop"><i class="fa fa-shopping-bag"></i><br><span>Bag</span></a>
            <a href="/account"><i class="fa fa-search"></i><br><span>Account</span></a>
            <a href="/notifications"><i class="fa fa-bell"></i><sup v-if="notifications_alert > 0" class="notify-alert">{{notifications_alert}}</sup><br><span>Notifications</span></a>
            <a href="/cart"><i class="fa fa-user"></i><br><span>Account</span></a>
            <!-- <a href="#news" style="font-size:22px;"><i class="fa fa-plus"></i><span>Add</span></a> -->
        </div>
    </div>

    <!---mobile-->
    <!-- <div class="bottombar" style="margin-top:15em; margin-left: -2em;width: 150%;"> -->
    <div style="display:none;" class="bottombar">
        <!-- <div style="margin-left:2.5em;"> -->
        <div>
            <a href="/"><i id="m_trending" class="fas fa-store-alt"></i><br><span>Trending</span></a>
            <!-- <a href="cart"><i id="m_cart" class="fa fa-shopping-bag"></i><br><span>Shopping</span></a>
            <a v-if="(active_shop_together_alert == 1)" href="/buypoint"><i id="m_feeds" style="color:#ff0000;" class="fa fa-users"></i><br><span>Shopping</span></a>
            <a v-else href="/feeds"><i id="m_feeds" class="fa fa-star"></i><br><span>Feeds</span></a>
            <a href="/notifications"><i id="m_notifications" class="fa fa-bell"></i><sup v-if="notifications_alert > 0" class="notify-alert">{{notifications_alert}}</sup><br><span>Notifications</span></a> -->
            <a href="/account"><i id="m_account" class="fa fa-user"></i><br><span>Orders</span></a>
            <!-- <a href="/chats"><i id="m_account" class="fa fa-comment"></i><br><span>Chat</span></a> -->
        </div>
    </div>
    <!--./mobile-->

    <div class="bottombar sp-app=default-background-color" style="border-top:none;">
        <!-- <div style="margin-left:2.5em;"> -->
        <div>
            <button class="sp-button-02 sp-button-oo"> Place Order</button>
        </div>
    </div>
   
    <!--./ fixed-bottom-nav -->
 </div>
</template>

<style>
    .p_order{
        width: 50% !important;
        /* border: #ff3c00 solid 1px; */
        border-radius: 15px;
        margin: 0.5em 0;
        /* width: 20%; */
        line-height: 1.8;
        float: left;
        display: block;
        color: #afafaf;
        text-decoration: none;
        font-size: 1.6em;
        height: auto;
        
    }
    .notify-alert{
        background: #ff3c00;
        color: #ffffff;
        font-size: 11px;
        padding: 0.2em 0.42em;
        border-radius: 50%;
    }
</style>


<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'MenuBottom',
    data () {
        return {
            user:{},
            notifications:{},
            notifications_alert:0,
            active_shop_together_alert:0,
        }
    },

    methods: {
        preset() {
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.getNotifications();
                }else {
                    // self.$router.push('login');
                }
            });
        },

        getNotifications(){
            service.getNotifications(this, this.user.user_id).then(response => {
                if(response.body.status == 200) {
                    this.notifications_alert = response.body.data_alert_total;
                }
            }).catch((err) => {})
        },
    },

    mounted: function() {
        let path = this.$route.path;
        if(path == "/"){document.getElementById("m_trending").style.color = "#000000";}
        if(path == "/cart"){document.getElementById("m_cart").style.color = "#000000";}
        if(path == "/search"){document.getElementById("m_search").style.color = "#000000";}
        if(path == "/feeds"){document.getElementById("m_feeds").style.color = "#000000";}
        if(path == "/notifications"){document.getElementById("m_notifications").style.color = "#000000";}
        if(path == "/account"){document.getElementById("m_account").style.color = "#000000";}
    },
    created: function() {
        if(localStorage.getItem("active_shop_together_alert")==1){
            this.active_shop_together_alert = 1;
        }
        // this.notifications.alert_no = 5;
        this.preset();
    }
}
</script>


// WEBPACK FOOTER //
// menubottom.vue?01b62816